import adVideoAsset from "@/assets/ad-video.mp4.asset.json";
import footerAdVideoAsset from "@/assets/footer-ad-video.mp4.asset.json";

const promoVideo = adVideoAsset.url;
const footerVideo = footerAdVideoAsset.url;

interface VideoBannerProps {
  variant?: "sidebar" | "footer";
}

const BANNER_LINK = "https://ppppen.shop";

// Sidebar banners for desktop (fixed on sides)
export const SidebarVideoBanners = () => {
  return (
    <>
      {/* Left sidebar - hidden on mobile/tablet */}
      <a 
        href={BANNER_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className="hidden xl:block fixed left-4 top-1/2 -translate-y-1/2 z-40 hover:opacity-90 transition-opacity"
      >
        <div className="w-[160px] rounded-xl overflow-hidden border border-border/50 shadow-lg">
          <video
            autoPlay
            muted
            loop
            playsInline
            className="w-full h-auto object-cover pointer-events-none"
            style={{ maxHeight: "400px" }}
          >
            <source src={promoVideo} type="video/mp4" />
          </video>
        </div>
      </a>

      {/* Right sidebar - hidden on mobile/tablet */}
      <a 
        href={BANNER_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className="hidden xl:block fixed right-4 top-1/2 -translate-y-1/2 z-40 hover:opacity-90 transition-opacity"
      >
        <div className="w-[160px] rounded-xl overflow-hidden border border-border/50 shadow-lg">
          <video
            autoPlay
            muted
            loop
            playsInline
            className="w-full h-auto object-cover pointer-events-none"
            style={{ maxHeight: "400px" }}
          >
            <source src={promoVideo} type="video/mp4" />
          </video>
        </div>
      </a>
    </>
  );
};



// Footer banner - visible on all screen sizes
const VideoBanner = ({ variant = "footer" }: VideoBannerProps) => {
  if (variant === "sidebar") {
    return <SidebarVideoBanners />;
  }

  // Footer variant - visible on all screens
  return (
    <a 
      href={BANNER_LINK} 
      target="_blank" 
      rel="noopener noreferrer"
      className="block relative overflow-hidden rounded-xl border border-border/50 my-6 hover:opacity-90 transition-opacity cursor-pointer"
    >
      <video
        autoPlay
        muted
        loop
        playsInline
        className="w-full h-auto object-cover pointer-events-none"
        style={{ maxHeight: "300px" }}
      >
        <source src={footerVideo} type="video/mp4" />
      </video>
    </a>
  );
};

export default VideoBanner;
